import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Absence, AbsencePdfRow } from '../models/absence.model';
import { environment } from '../../environments/environment';
import { Activity } from '../models/activity.model';
import { AbsenceNotification } from '../models/absence-notification.model';

@Injectable({ providedIn: 'root' })
export class AbsenceService {
  private apiUrl = environment.apiUrl + '/Absence';

  http = inject(HttpClient);

  createAbsence(absenceData: Absence): Observable<Activity> {
    return this.http.post<Activity>(
      `${this.apiUrl}/CreateAbsence`,
      absenceData
    );
  }

  updateAbsence(absence: Absence): Observable<Activity> {
    return this.http.put<Activity>(
      `${this.apiUrl}/UpdateAbsence/${absence.absenceId}`,
      absence
    );
  }

  getNotifications(): Observable<AbsenceNotification[]> {
    return this.http.get<AbsenceNotification[]>(`${this.apiUrl}/notification`);
  }

  markNotificationAbsenceCreated(
    notificationId: number,
    activityId?: number
  ): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/notification/${notificationId}/mark-absence-created`,
      { activityId }
    );
  }

  archiveNotification(notificationId: number): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/notification/${notificationId}`
    );
  }

  generatePdf(tableData: AbsencePdfRow[], coursename: string): Observable<Blob> {
    return this.http.post(
      environment.apiUrl + `/Pdf/${coursename}/absences`,
      tableData,
      {
        responseType: 'blob',
      }
    );
  }
}
